import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    attachmentAudioData: { attachmentUrl: '', type: 'stop' },
    timeListAll: {}
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
    getAttachmentAudioData(state) {
      return state.attachmentAudioData
    },
    getMakeAnAppointmentTime(state) {
      return state.timeListAll
    }
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setAttachmentAudioData(state, attachmentAudioData) {
      state.attachmentAudioData = attachmentAudioData
    },
    setMakeAnAppointmentTime(state, timeList) {
      state.timeListAll = Object.assign(state.timeListAll, timeList)
    },
    eliminateMakeAnAppointmentTime(state, nullObj) {
      state.timeListAll = nullObj
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    },
    setAttachmentAudioData({ commit }, attachmentAudioData) {
      commit('setAttachmentAudioData', attachmentAudioData)
    },
    setMakeAnAppointmentTime({ commit }, timeList) {
      commit('setMakeAnAppointmentTime', timeList)
    },
    eliminateMakeAnAppointmentTime({ commit }, nullObj) {
      commit('eliminateMakeAnAppointmentTime', nullObj)
    }
  }
})
